import * as general from './general';
import * as location from './location';

export default {
  ...general,
  ...location,
};
